/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/url_encode_component.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * URL-encodes the input. All characters are percent-encoded except for alphanumerics, `.`, `-`, `_`, and `~`. Spaces are encoded as `%20`.
 *
 * @example
 * ROW u = "https://example.com/?x=foo bar&y=baz"
 * | EVAL u = URL_ENCODE_COMPONENT(u)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'url_encode_component',
  signatures: [
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
